import React from 'react'

export const AssignDriverIcon: React.FC<{ color?: string; size?: number }> = ({ color = '#5F6D7E', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    stroke={color}
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
  >
    <title>Assign Driver</title>
    {/* A slightly smaller person to give the plus sign more room */}
    <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2'></path>
    <circle cx='8' cy='7' r='4'></circle>

    {/* A cleaner, more balanced plus sign */}
    <line x1='19' y1='8' x2='19' y2='14'></line>
    <line x1='16' y1='11' x2='22' y2='11'></line>
  </svg>
)
